/**
 * Central pause/resume control for the SDK's MutationObserver.
 *
 * Every code path that writes translations into the DOM must run while the
 * observer is paused, so the SDK never reacts to its own writes (which would
 * otherwise trigger redundant traversals and duplicate translation API calls).
 *
 * Pausing is ref-counted, so nested pause/resume calls are safe:
 * the observer only reconnects when the outermost caller resumes.
 */

let pauseFn = null;
let resumeFn = null;
let pauseDepth = 0;

// Called once by the observer owner (sdk/index.js) after creating the observer.
function registerObserverControl(pause, resume) {
  pauseFn = pause;
  resumeFn = resume;
}

function pauseObserver() {
  pauseDepth++;
  if (pauseDepth === 1 && pauseFn) {
    pauseFn();
  }
}

function resumeObserver() {
  if (pauseDepth === 0) return;
  pauseDepth--;
  if (pauseDepth === 0 && resumeFn) {
    resumeFn();
  }
}

// Runs fn (sync or async) with the observer paused; always resumes.
async function withObserverPaused(fn) {
  pauseObserver();
  try {
    return await fn();
  } finally {
    resumeObserver();
  }
}

module.exports = {
  registerObserverControl,
  pauseObserver,
  resumeObserver,
  withObserverPaused
};
